module.exports = __webpack_public_path__ + "media/images/front/about/bg_member-cdd472e7573a0f7f756f30c34c6af3b3.jpg";